import React from 'react';
import style from './style';

function Presenter({remaining,progress,...props}){
	const min = Math.floor(remaining / 60 / 1000);
	const minStr = ( '00' + min ).slice( -2 );
	const sec = Math.floor((remaining - (min * 60 * 1000))/1000);
	const secStr = ( '00' + sec ).slice( -2 );
	return (
		<style.Wrapper {...props}>
			<style.Progresbar>
				<style.Progress progress={progress}/>
			</style.Progresbar>
			<style.TimerIcon />
			<style.Min>{minStr}</style.Min>
			<style.Sec>:{secStr}</style.Sec>
		</style.Wrapper>
	);
}

export default Presenter;